// extracted by mini-css-extract-plugin
export default {"bankTab":"Bank_bankTab__LLWL4","bankTabForm":"Bank_bankTabForm__ikDcd"};